import { Injectable } from '@angular/core';
import { ConfigurationDto } from './configuration-api.service';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  playbookClauseMaxSizeInCharacters!: number;
  keyQuestionMaxSizeInCharacters!: number;
  addClauseInstructionsMaxSizeInCharacters!: number;
  questionMaxSizeInCharacters!: number;
  rewriteInstructionsMaxSizeInCharacters!: number;
  contentToRewriteMaxSizeInCharacters!: number;
  // makeMoreConciseMaxSizeInCharacters!: number;

  constructor() {}

  async init(config: ConfigurationDto): Promise<AppConfigService> {
    return new Promise((resolve) => {
      Object.assign(this, {
        playbookClauseMaxSizeInCharacters: config.playbookClauseMaxSizeInCharacters,
      });
      Object.assign(this, {
        keyQuestionMaxSizeInCharacters: config.keyQuestionMaxSizeInCharacters,
      });
      Object.assign(this, {
        addClauseInstructionsMaxSizeInCharacters: config.addClauseInstructionsMaxSizeInCharacters,
      });
      Object.assign(this, { questionMaxSizeInCharacters: config.questionMaxSizeInCharacters });
      Object.assign(this, {
        rewriteInstructionsMaxSizeInCharacters: config.rewriteInstructionsMaxSizeInCharacters,
      });
      Object.assign(this, {
        contentToRewriteMaxSizeInCharacters: config.contentToRewriteMaxSizeInCharacters,
      });
      Object.assign(this, { makeMoreConciseMaxSizeInCharacters: 250 });

      resolve(this);
    });
  }
}
